import { useQuery } from '@tanstack/react-query'
import { useRfxHttpClient } from '@omnea-app/fe-rfx/useRfxHttpClient'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'

const getMyActiveRfxsQueryKey = 'myRfxsQueryKey'

export const useGetMyActiveRfxs = () => {
  const rfxHttpClient = useRfxHttpClient()

  return useQuery({
    queryKey: [getMyActiveRfxsQueryKey],
    queryFn: async () => {
      const { data, error } = await rfxHttpClient.GET('/')
      throwIfApiError(error)
      return data
    },
  })
}
